/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Contract_Status_Enum =
  | 'SIGNED'
  | 'UNSIGNED';

export type CustomPriceListByIdQueryVariables = Exact<{
  id: string;
}>;


export type CustomPriceListByIdQuery = { custom_price_list_by_pk: { id: string, name: string, company_id: string, created_at: string, reference_id: string, custom_price_list_packagings: Array<{ discount: number, id: string, packaging_sku: number }>, contracts: Array<{ id: string, status: Types.Contract_Status_Enum, reference_id: string }> } | null };


export const CustomPriceListByIdDocument = /*#__PURE__*/ gql`
    query CustomPriceListById($id: uuid!) {
  custom_price_list_by_pk(id: $id) {
    id
    name
    company_id
    created_at
    reference_id
    custom_price_list_packagings {
      discount
      id
      packaging_sku
    }
    contracts(order_by: {buying_company: {tradeName: asc}}) {
      id
      status
      reference_id
    }
  }
}
    `;

/**
 * __useCustomPriceListByIdQuery__
 *
 * To run a query within a React component, call `useCustomPriceListByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomPriceListByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomPriceListByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomPriceListByIdQuery(baseOptions: Apollo.QueryHookOptions<CustomPriceListByIdQuery, CustomPriceListByIdQueryVariables> & ({ variables: CustomPriceListByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomPriceListByIdQuery, CustomPriceListByIdQueryVariables>(CustomPriceListByIdDocument, options);
      }
export function useCustomPriceListByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomPriceListByIdQuery, CustomPriceListByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomPriceListByIdQuery, CustomPriceListByIdQueryVariables>(CustomPriceListByIdDocument, options);
        }
// @ts-ignore
export function useCustomPriceListByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomPriceListByIdQuery, CustomPriceListByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CustomPriceListByIdQuery, CustomPriceListByIdQueryVariables>;
export function useCustomPriceListByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomPriceListByIdQuery, CustomPriceListByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CustomPriceListByIdQuery | undefined, CustomPriceListByIdQueryVariables>;
export function useCustomPriceListByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomPriceListByIdQuery, CustomPriceListByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomPriceListByIdQuery, CustomPriceListByIdQueryVariables>(CustomPriceListByIdDocument, options);
        }
export type CustomPriceListByIdQueryHookResult = ReturnType<typeof useCustomPriceListByIdQuery>;
export type CustomPriceListByIdLazyQueryHookResult = ReturnType<typeof useCustomPriceListByIdLazyQuery>;
export type CustomPriceListByIdSuspenseQueryHookResult = ReturnType<typeof useCustomPriceListByIdSuspenseQuery>;
export type CustomPriceListByIdQueryResult = Apollo.QueryResult<CustomPriceListByIdQuery, CustomPriceListByIdQueryVariables>;